    <div class="car-detail" *ngIf="!loading; else spinner">
      <div class="page-header">
        <button mat-icon-button routerLink="/cars" aria-label="Назад">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1 class="page-title">{{ car?.title || 'Загрузка...' }}</h1>
      </div>

      <mat-card *ngIf="car" class="detail-card">
        <mat-card-content>
          <div class="car-status-row">
            <span>Статус:</span>
            <mat-chip-set>
              <mat-chip [class]="'status-chip status-' + availability?.status" selected>
                {{ availability ? (availability.status | statusLabel:'availability') : '—' }}
              </mat-chip>
            </mat-chip-set>
          </div>

          <mat-list>
            <mat-list-item *ngIf="availability?.license_plate !== undefined">
              <mat-icon matListItemIcon>confirmation_number</mat-icon>
              <span matListItemTitle>Госномер</span>
              <span matListItemLine>{{ availability?.license_plate || '—' }}</span>
            </mat-list-item>
            <mat-list-item *ngIf="car.car_brand">
              <mat-icon matListItemIcon>branding_watermark</mat-icon>
              <span matListItemTitle>Бренд</span>
              <span matListItemLine>{{ car.car_brand?.title }}</span>
            </mat-list-item>
            <mat-list-item *ngIf="car.car_model">
              <mat-icon matListItemIcon>directions_car</mat-icon>
              <span matListItemTitle>Модель</span>
              <span matListItemLine>{{ car.car_model?.title }}</span>
            </mat-list-item>
            <mat-list-item *ngIf="car.release_year">
              <mat-icon matListItemIcon>calendar_today</mat-icon>
              <span matListItemTitle>Год выпуска</span>
              <span matListItemLine>{{ car.release_year }}</span>
            </mat-list-item>
            <mat-list-item>
              <mat-icon matListItemIcon>speed</mat-icon>
              <span matListItemTitle>Лимит пробега</span>
              <span matListItemLine>{{ car.mileage_limit ?? '—' }} км/сутки</span>
            </mat-list-item>
            <mat-list-item *ngIf="car.transmission_type">
              <mat-icon matListItemIcon>settings</mat-icon>
              <span matListItemTitle>КПП</span>
              <span matListItemLine>{{ car.transmission_type?.title }}</span>
            </mat-list-item>
            <mat-list-item *ngIf="car.body_type">
              <mat-icon matListItemIcon>directions_car_fill</mat-icon>
              <span matListItemTitle>Кузов</span>
              <span matListItemLine>{{ car.body_type?.title }}</span>
            </mat-list-item>
          </mat-list>

          <div class="price-section" *ngIf="car.price_rent">
            <div class="price-row">
              <span>Аренда в сутки:</span>
              <span class="price-value">{{ car.price_rent }} &#8381;</span>
            </div>
            <div class="price-row" *ngIf="car.price_deposit">
              <span>Залог:</span>
              <span class="price-value">{{ car.price_deposit }} &#8381;</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <div class="actions" *ngIf="car && availability?.status === 'free'">
        <button mat-raised-button color="primary" class="full-width-btn"
                [routerLink]="['/bookings/new']" [queryParams]="{car: car!.id}">
          <mat-icon>event_available</mat-icon>
          Забронировать
        </button>
      </div>

      <div class="timeline-section">
        <h2 class="section-title">Брони и прокаты</h2>

        <div class="timeline-loading" *ngIf="timelineLoading">
          <mat-spinner diameter="32"></mat-spinner>
        </div>

        <ng-container *ngIf="!timelineLoading">
          <div class="timeline-entry" *ngFor="let entry of activeTimeline">
            <app-booking-card *ngIf="entry.kind === 'booking'"
                              [booking]="entry.booking" [showCarInfo]="true"
                              [showTypeBadge]="true"></app-booking-card>
            <app-rental-card *ngIf="entry.kind === 'rental'"
                             [rental]="entry.rental" [showCarInfo]="true"
                             [showHandoverLabel]="false"
                             [showTypeBadge]="true"></app-rental-card>
          </div>

          <p class="timeline-empty" *ngIf="timeline.length === 0">
            Брони и прокаты отсутствуют
          </p>

          <mat-accordion *ngIf="finishedTimeline.length > 0" class="timeline-finished-accordion">
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>Завершённые ({{ finishedTimeline.length }})</mat-panel-title>
              </mat-expansion-panel-header>
              <div class="timeline-entry" *ngFor="let entry of finishedTimeline">
                <app-booking-card *ngIf="entry.kind === 'booking'"
                                  [booking]="entry.booking" [showCarInfo]="true"
                                  [showTypeBadge]="true"></app-booking-card>
                <app-rental-card *ngIf="entry.kind === 'rental'"
                                 [rental]="entry.rental" [showCarInfo]="true"
                                 [showHandoverLabel]="false"
                                 [showTypeBadge]="true"></app-rental-card>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-container>
      </div>
    </div>

    <ng-template #spinner>
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    </ng-template>
